var map = {
	"./RankIconColor.svg": 2103,
	"./add-gradient.svg": 2104,
	"./add-icon.svg": 2105,
	"./add.svg": 2106,
	"./alarm-icon.svg": 2107,
	"./arrow-breadcrumbs.svg": 2108,
	"./arrow-down.svg": 2109,
	"./arrow.svg": 2110,
	"./arrow_right.svg": 2111,
	"./auth.svg": 2112,
	"./badges-blue-icon.svg": 2113,
	"./badges-icon.svg": 2114,
	"./book-open.svg": 2115,
	"./calendar.svg": 2116,
	"./calendar2.svg": 2117,
	"./camera.svg": 2118,
	"./chat-dots.svg": 2119,
	"./check-completed.svg": 2120,
	"./check-in-circle-gradient.svg": 2121,
	"./check-in-dark.svg": 2122,
	"./checkbox-selected.svg": 2123,
	"./chevron-blue-badge.svg": 2124,
	"./close-catalog.svg": 2125,
	"./close-training.svg": 2126,
	"./close.svg": 2127,
	"./copy.svg": 2128,
	"./correct-answer.svg": 2129,
	"./correctAnswer.svg": 2130,
	"./correctAnswerWide.svg": 2131,
	"./course-icon.svg": 2132,
	"./cross.svg": 2133,
	"./decrease.svg": 2134,
	"./delete-danger.svg": 2135,
	"./delete.svg": 2136,
	"./download-icon.svg": 2137,
	"./dustbin-active.svg": 2138,
	"./dustbin.svg": 2139,
	"./email-in-circle-gradient.svg": 2140,
	"./email.svg": 2141,
	"./emoji.svg": 2142,
	"./error-warning-fill.svg": 2143,
	"./error.svg": 2144,
	"./export.svg": 2145,
	"./favorite.svg": 2146,
	"./featured.svg": 2147,
	"./film.svg": 2148,
	"./filter-icon.svg": 2149,
	"./flag-icon.svg": 2150,
	"./folder-language.svg": 2151,
	"./folder.svg": 2152,
	"./heart.svg": 2153,
	"./heart_full.svg": 2154,
	"./import.svg": 2155,
	"./incorrect-answer.svg": 2156,
	"./increase.svg": 2157,
	"./info-builder.svg": 2158,
	"./info-icon-sky.svg": 2159,
	"./info-icon.svg": 2160,
	"./info.svg": 2161,
	"./left-gray-arrow.svg": 2162,
	"./levels-icon.svg": 2163,
	"./loader.svg": 2164,
	"./logo/horizontal/blue_black.svg": 2165,
	"./logo/horizontal/blue_blue_white.svg": 2166,
	"./logo/horizontal/blue_white.svg": 2167,
	"./menu.svg": 2168,
	"./message.svg": 2169,
	"./minus-icon.svg": 2170,
	"./more.svg": 2171,
	"./new-arrival.svg": 2172,
	"./notification_icon.svg": 2173,
	"./options.svg": 2174,
	"./pdf-file.svg": 2175,
	"./pdf-white.svg": 2176,
	"./personalized.svg": 2177,
	"./play-button-blue.svg": 2178,
	"./play-button-content.svg": 2179,
	"./play-button-dark-circle.svg": 2180,
	"./play-button-white-circle-solid.svg": 2181,
	"./play-button-white-circle.svg": 2182,
	"./play-button.svg": 2183,
	"./play-content-completed.svg": 2184,
	"./plus-icon.svg": 2185,
	"./products/phishing.svg": 2186,
	"./products/teams.svg": 2187,
	"./products/training.svg": 2188,
	"./products/unify.svg": 2189,
	"./profile.svg": 2190,
	"./puzzle-dark.svg": 2191,
	"./puzzle-white.svg": 2192,
	"./puzzle.svg": 2193,
	"./question.svg": 2194,
	"./quiz-dark.svg": 2195,
	"./quiz-white.svg": 2196,
	"./rank-icon.svg": 2197,
	"./recurrence.svg": 2198,
	"./refresh.svg": 2199,
	"./remove.svg": 2200,
	"./reorder.svg": 2201,
	"./repeat.svg": 2202,
	"./right-blue-arrow.svg": 2203,
	"./round-add-dark.svg": 2204,
	"./schedule.svg": 2205,
	"./search-icon.svg": 2206,
	"./selector.svg": 2207,
	"./settings.svg": 2208,
	"./sidebar-menu/icon-risk.svg": 2209,
	"./sidebar-menu/icon-strategy.svg": 2210,
	"./sidebar-menu/icon-training.svg": 2211,
	"./skip-video-arrow.svg": 2212,
	"./slider-arrow.svg": 2213,
	"./star-icon.svg": 2214,
	"./stop-button-white-circle-solid.svg": 2215,
	"./success.svg": 2216,
	"./tag-loader.svg": 2217,
	"./text-block-white.svg": 2218,
	"./text-block.svg": 2219,
	"./trophy1.svg": 2220,
	"./trophy2.svg": 2221,
	"./trophy3.svg": 2222,
	"./video-catalog.svg": 2223,
	"./video.svg": 2224,
	"./video2.svg": 2225,
	"./warning.svg": 2226,
	"./wideCross.svg": 2227,
	"./zoom-out.svg": 2228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2102;